import { z } from "zod";
import { ReportBrief } from "../ReportBrief.js";
import type { AssertSchemaMatchesClass } from "../../../utils/typeUtils.js";
import { JobStatuses } from "@/entities/JobStatus.js";
import { RiskRanksWithNA } from "@/entities/risk/Risk.js";



const _ReportZod = z.object({
  reportTitle: z.string().default(""),
  reportLink: z.string().nullable().default(null),
  reportLabel: z.string().default(""),
  reportId: z.string().default(""),
  reportType: z.string().default(""),

  statusMessage: z.string().default(""),
  status: z.enum(JobStatuses).default("none"),

  contentVersion: z.number().default(0),
  overallRiskRank: z.enum(RiskRanksWithNA).catch("n/a").default("n/a"),
  isStale: z.boolean().default(false),
  useCaseChatId: z.string().default(""),
  riskProfileId: z.string().default(""),
})

// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _ReportZod, ReportBrief>);

export const ReportSchema = _ReportZod.transform((data) => new ReportBrief(data));


